module.exports = __webpack_public_path__ + "static/img/陪护申请@3x.3fb4e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/陪护申请@3x.png
// module id = 322
// module chunks = 379 380